<template>
  <!-- 要 picture、name(或者title)、id-->
  <div v-if="!isMobile()" :style="'width:'+(100/column).toFixed(2)+'%'" class="card-body">
    <el-card shadow="hover" class="pointer">
      <a style="height: 250px" :href="href" target="_blank">
        <el-image class="card-img" :src="formatUrl(imgsrc)"></el-image>
        <b class="font-overflow card-title">{{title}}</b>
      </a>
      <div class="card-footer">
        <el-button class="footer-btn" style="float: left;color: grey" type="text">学而时习之</el-button>
        <el-button class="footer-btn" type="text"><i class="el-icon-thumb"></i> <a :href="href" target="_blank">点击查看</a></el-button>
      </div>
    </el-card>
  </div>
  <el-card v-else class="box-card">
    <a style="height: 250px" :href="href" target="_blank">
      <el-image class="card-img" :src="formatUrl(imgsrc)"></el-image>
      <b class="font-overflow card-title">{{title}}</b>
    </a>
    <div class="card-footer">
      <el-button class="footer-btn" style="float: left;color: grey" type="text">学而时习之</el-button>
      <el-button class="footer-btn" type="text"><i class="el-icon-thumb"></i> <a :href="href" target="_blank">点击查看</a></el-button>
    </div>
  </el-card>

</template>
<script>
  export default {
    props: {
      title: {
        type: String,
        default: ""
      },
      imgsrc: {
        type: String,
        default: ""
      },
      content: {
        type: String,
        default: ""
      },
      href: {
        type: String,
        default: ""
      },
      column: {
        type: Number,
        default: 6.5
      },
    },
  };
</script>
<style scoped>
  .card-body {
    float: left;
    margin-right: 10px;
  }
  .content {
    font-size: 14px;
    color: #999;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .card-img {
    border-radius: 5px;
    height: 180px;
    width: 100%
  }

  .card-title {
    text-align: center;
    display: block;
    font-family: cursive
  }

  .footer-time {
    float: left;
    font-size: 14px;
    color: #999;
    margin-top: 5px;
  }

  .footer-btn {
    float: right;
    margin-bottom: 5px
  }
</style>



// WEBPACK FOOTER //
// src/components/sui-course/sui-course.vue